import React from 'react';
import loadingView from '../../assets/icons/loading_view.gif';

const LoadingSpinner = ({ size }) => {
  return (
    <div className={`flex flex-col items-center justify-center ${size === "small" ? "p-4" : "p-16"}`}>
      <img 
        src={loadingView} 
        alt="Loading" 
        width={size === 'small' ? 104 : 254}
        height={size === 'small' ? 102 : 242}
        className="object-contain"
      />
      {size !== 'small' && <div className="mt-4 text-gray-600 text-lg font-medium">Loading...</div>}
    </div>
  );
};

export default LoadingSpinner; 